import '../../../assets/login.css';

import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { Button } from 'shards-react';
import InputAuth from '../../../components/UI/Input/InputAuth';

const ResetPassword = () => {
  const { submitHandler, field, loading, showResetPassword, resendResetEmail } = useForm();
  const { t } = useTranslation();

  return (
    <div className="col-lg-12 col-sm-12 login-banner">
      <div className="row d-flex justify-content-center ">
        {showResetPassword ? (
          <div className="col-lg-5 registration-card">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <h2 className="login-card-title p-2">{t('reset-password.title')}</h2>
                </div>
                <div className="col-12">
                  <form>
                    <div className="col-12 form-group ">
                      <div className="form-group mb-3">
                        <InputAuth
                          type="password"
                          className={` form-control  pt-3 pb-3 `}
                          id="password"
                          placeholder={t('reset-password.password')}
                          {...field('password')}
                        />
                      </div>

                      <div className="form-group login-form-input">
                        <InputAuth
                          type="password"
                          className={` form-control  pt-3 pb-3 `}
                          id="password-confirmation"
                          placeholder={t('reset-password.password-confirmation')}
                          {...field('password_confirm')}
                        />
                        <button
                          className=" input-divider reset-password-btn"
                          type="button"
                          disabled={loading}
                          onClick={() => resendResetEmail()}
                        >
                          <span className="glyphicon glyphicon-repeat"></span> {t('reset-password.resend')}
                        </button>
                      </div>
                      <div className="valid-feedback">{t('reset-password.reset')}</div>
                      <div className="d-flex flex-column justify-content-md-center mt-3">
                        <Button
                          className="btn btn-warning  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                          type="button"
                          disabled={loading}
                          onClick={() => submitHandler()}
                          style={{ fontSize: '20px' }}
                        >
                          <span
                            className="spinner-border "
                            role="status"
                            aria-hidden="true"
                            style={{ display: loading === true ? 'block' : 'none' }}
                          ></span>
                          <span className=""> {t('reset-password.reset')}</span>
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-lg-5 registration-card" style={{ marginTop: '250px' }}>
            <div className="container">
              <div className="row mt-2 d-flex justify-content-between">
                <div className="col-12 text-center">
                  <h2 className="login-card-title p-2">{t('ERROR_INVALID_CODE')}</h2>
                </div>
                <div className="col-lg-12"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
